module.exports = __webpack_public_path__ + "img/building-gray.6b80013d.png";